import _defineProperty from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("vue-editor", {
    staticStyle: {
      display: "none"
    }
  }), _c("canvas", {
    attrs: {
      id: "canvas"
    }
  }), _c("div", {
    staticStyle: {
      flex: "1",
      "margin-bottom": "env(safe-area-inset-bottom)",
      "padding-bottom": "55px"
    }
  }, [_vm.showDetailBack ? _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.share
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_share.png"),
      alt: ""
    }
  })])]) : _vm._e(), _vm.$route.query.from != "video" && _vm.$route.query.from != "community" && _vm.$route.query.from != "club" ? _c("div", {
    staticClass: "img-con"
  }, [Object.prototype.toString.call(_vm.detailData["content"]["indexes"]) == "[object Object]" && _vm.detailData["content"]["indexes"]["101"]["body"].length > 0 && _vm.detailData["content"]["indexes"]["101"]["body"][0].type != 2 ? _c("img", {
    attrs: {
      src: _vm.detailData["content"]["indexes"]["101"]["body"][0].thumbUrl,
      alt: ""
    }
  }) : _vm._e()]) : _vm._e(), _vm.$route.query.from == "video" ? _c("div", {
    staticClass: "video-con"
  }, [_c("video", {
    staticClass: "video",
    attrs: {
      controls: "",
      src: ""
    }
  })]) : _vm._e(), _vm.$route.query.from == "video" ? _c("div", {
    staticClass: "video-detail"
  }, [_c("div", {
    staticClass: "user"
  }, [_c("div", {
    staticClass: "user-info",
    on: {
      click: function click($event) {
        return _vm.toMe(_vm.detailData.user.userId);
      }
    }
  }, [_vm.detailData.user.avatar ? _c("img", {
    staticClass: "img",
    attrs: {
      src: _vm.detailData.user.avatar,
      alt: ""
    }
  }) : _c("img", {
    staticClass: "img",
    attrs: {
      src: require("../../assets/images/icon_avatar.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "txt"
  }, [_c("span", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.detailData.user.nickname))]), _c("span", {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.detailData.createdAt))])])])]), _c("div", {
    staticClass: "text"
  }, [_vm._v("In 2020, MG launched MG Pilot, which is another representative product of MG after HS. So is MG Pilot worth buying?")]), _vm._m(0)]) : _vm._e(), _vm.$route.query.from == "activity" ? _c("div", [_c("div", {
    staticClass: "activity-article"
  }, [_c("h4", [_vm._v(_vm._s(_vm.detailData.title))]), _c("div", {
    staticClass: "position-time"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm.detailData.start_at || _vm.detailData.end_at ? _c("div", {
    staticClass: "time"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_mg_activity_time.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.detailData.start_at) + " - " + _vm._s(_vm.detailData.end_at))])]) : _vm._e(), _vm.detailData.position.address ? _c("div", {
    staticClass: "position"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_mg_activity_address.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.detailData.position.address))])]) : _vm._e()]), _c("div", {
    staticClass: "right"
  }, [_c("span", {
    staticClass: "num"
  }, [_vm._v(_vm._s(this.joinNum))]), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("joined")))])])]), _c("div", {
    staticClass: "activity-text ql-editor",
    domProps: {
      innerHTML: _vm._s(_vm.detailData.content.text)
    }
  }), Object.prototype.toString.call(_vm.detailData["content"]["indexes"]) == "[object Object]" && _vm.detailData["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
    staticClass: "item-wrap"
  }, _vm._l(_vm.shiftArr, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: item.thumbUrl,
        alt: ""
      }
    })]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "link"
  }, [_vm.detailData.activity_link_title ? _c("span", [_vm._v(_vm._s(_vm.detailData.activity_link_title))]) : _vm._e(), _vm.detailData.activity_link ? _c("span", [_vm._v(_vm._s(_vm.detailData.activity_link))]) : _vm._e()]), _c("div", {
    staticClass: "line"
  })]), new Date() > Date.parse(_vm.detailData.end_time2) && !_vm.detailData.activity_registration ? _c("div", {
    staticClass: "sign-up2"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("join")))])]) : new Date() > Date.parse(_vm.detailData.end_time2) && _vm.detailData.activity_registration ? _c("div", {
    staticClass: "sign-up2"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("joined")))])]) : !_vm.detailData.activity_registration ? _c("div", {
    class: ["sign-up-btn", {
      disabled: _vm.isDisabled
    }],
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toSign(1);
      }
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("Join")))])]) : _c("div", {
    staticClass: "sign-up",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toSign(0);
      }
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("joined")))])])]) : _vm._e(), _vm.$route.query.from == "club" || _vm.$route.query.from == "news" || _vm.$route.query.from == "community" ? _c("div", [_c("div", {
    staticClass: "article"
  }, [_c("h4", [_vm._v(_vm._s(_vm.detailData.title))]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$route.query.from == "club" || _vm.$route.query.from == "community",
      expression: "$route.query.from == 'club' || $route.query.from == 'community'"
    }],
    staticClass: "user"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.userInfoShow,
      expression: "userInfoShow"
    }],
    staticClass: "user-info"
  }, [_vm.detailData.user.avatar ? _c("img", {
    staticClass: "img",
    attrs: {
      src: _vm.detailData.user.avatar,
      alt: ""
    }
  }) : _c("img", {
    staticClass: "img",
    attrs: {
      src: require("../../assets/images/icon_avatar.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "txt"
  }, [_c("span", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.detailData.user.nickname))]), _c("span", {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.detailData.createdAt))])])]), _vm.storeUserId != _vm.detailData.user.userId ? _c("div", [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detailData.user.follow_status == 2,
      expression: "detailData.user.follow_status == 2"
    }],
    staticClass: "follow",
    on: {
      click: function click($event) {
        return _vm.toFollow(_vm.detailData.user.userId);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Follow")))]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detailData.user.follow_status == 1,
      expression: "detailData.user.follow_status == 1"
    }],
    staticClass: "unFollow",
    on: {
      click: function click($event) {
        return _vm.toUnfollow(_vm.detailData.user.userId);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("friend")))]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detailData.user.follow_status == 0,
      expression: "detailData.user.follow_status == 0"
    }],
    staticClass: "unFollow",
    on: {
      click: function click($event) {
        return _vm.toUnfollow(_vm.detailData.user.userId);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Unfollow")) + " ")])]) : _vm._e()]), _c("div", {
    staticClass: "content ql-editor",
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      innerHTML: _vm._s(_vm.detailData.content.text)
    }
  }), Object.prototype.toString.call(_vm.detailData["content"]["indexes"]) == "[object Object]" && _vm.detailData["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
    staticClass: "item-wrap"
  }, [_vm._l(_vm.detailData["content"]["indexes"]["101"]["body"], function (item) {
    return _vm.$route.query.from == "community" ? _c("div", {
      key: item.id,
      staticClass: "item"
    }, [item.type == 1 ? _c("img", {
      attrs: {
        src: item.thumbUrl,
        alt: ""
      }
    }) : _vm._e(), item.type == 2 ? _c("div", {
      staticClass: "video-cons"
    }, [item.type == 2 ? _c("video", {
      staticClass: "video",
      attrs: {
        controls: "",
        controlslist: "nodownload noremoteplayback",
        poster: item.poster,
        "x5-playsinline": "",
        playsinline: "true",
        "webkit-playsinline": "",
        src: item.url
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e();
  }), _vm._l(_vm.shiftArr, function (item) {
    return _vm.$route.query.from == "club" ? _c("div", {
      key: item.id,
      staticClass: "item"
    }, [item.type == 1 || item.type == 0 ? _c("img", {
      attrs: {
        src: item.thumbUrl,
        alt: ""
      }
    }) : _vm._e(), item.type == 2 ? _c("div", {
      staticClass: "video-cons"
    }, [item.type == 2 ? _c("video", {
      staticClass: "video",
      attrs: {
        controls: "",
        autoplay: "",
        controlslist: "nodownload noremoteplayback",
        poster: item.poster,
        "x5-playsinline": "",
        playsinline: "true",
        "webkit-playsinline": "",
        src: item.url
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e();
  })], 2) : _vm._e()]), _vm.$route.query.from == "club" && _vm.detailData.thread_topic && _vm.detailData.thread_topic.length > 0 ? _c("div", {
    staticClass: "tags"
  }, _vm._l(_vm.detailData.thread_topic, function (item1) {
    return _c("div", {
      key: item1.id,
      staticClass: "tags-item",
      on: {
        click: function click($event) {
          return _vm.toTopic(item1.id);
        }
      }
    }, [_c("img", {
      staticClass: "sign",
      attrs: {
        src: require("../../assets/images/Topic-list-icon-blue.png"),
        alt: ""
      }
    }), _c("span", {
      staticClass: "clubs"
    }, [_vm._v(_vm._s(item1.content))])]);
  }), 0) : _vm._e(), _vm.detailData.user.userId == _vm.storeUserId ? _c("div", {
    staticClass: "buttop-wrap"
  }, [_c("van-button", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.delPostShow,
      expression: "delPostShow"
    }],
    attrs: {
      type: "danger",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.toDelete(_vm.detailData.threadId);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("delPost")))])], 1) : _vm._e(), _c("div", {
    staticClass: "comments"
  }, [_vm.detailData.is_comment == 1 || _vm.detailData.is_comment === null ? _c("h4", [_vm._v(_vm._s(_vm.$t("AllComments")))]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commentList.length == 0 && _vm.isCommentShow && (_vm.detailData.is_comment == 1 || _vm.detailData.is_comment === null),
      expression: "commentList.length == 0 && isCommentShow && (detailData.is_comment == 1 || detailData.is_comment === null)"
    }],
    staticClass: "noComment"
  }, [_vm._v(" " + _vm._s(_vm.$t("NoComments")))]), _vm.commentList.length > 0 ? _c("div", [_c("van-list", {
    attrs: {
      "loading-text": _vm.$t("LoadingTxt"),
      finished: _vm.finished,
      "finished-text": _vm.$t("NoMoreContents")
    },
    on: {
      load: _vm.onload
    },
    model: {
      value: _vm.loading,
      callback: function callback($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, _vm._l(_vm.commentList, function (item) {
    return _c("div", {
      key: item.id,
      class: ["commnets-item", {
        selected: item.isSelected
      }],
      on: {
        touchstart: function touchstart($event) {
          return _vm.start(item.userId, item.id, item);
        }
      }
    }, [_c("div", {
      staticClass: "user"
    }, [_c("div", {
      staticClass: "user-info",
      on: {
        click: function click($event) {
          return _vm.toReply(item.user.nickname, item.id);
        }
      }
    }, [item.user.avatar ? _c("img", {
      staticClass: "img",
      attrs: {
        src: item.user.avatar,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "txt"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.user.nickname))]), _c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.createdAt))])])]), _c("div", {
      staticClass: "comments-goods",
      on: {
        click: function click($event) {
          return _vm.thumbsUp(item.id, item.isLiked);
        }
      }
    }, [!item.isLiked ? _c("img", {
      attrs: {
        src: require("../../assets/images/ic_other_more_like.png"),
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("../../assets/images/Like1.png"),
        alt: ""
      }
    }), item.likeCount ? _c("span", [_vm._v(_vm._s(item.likeCount))]) : _c("span")])]), _c("div", {
      staticClass: "comments-con"
    }, [_c("span", {
      staticClass: "text",
      domProps: {
        innerHTML: _vm._s(item.content)
      },
      on: {
        click: function click($event) {
          return _vm.toReply(item.user.nickname, item.id);
        }
      }
    }), item.userId == _vm.storeUserId ? _c("img", {
      staticStyle: {
        "pointer-events": "auto !important",
        height: "5vw",
        width: "5vw",
        float: "right",
        "margin-right": "7vw",
        "z-index": "999"
      },
      attrs: {
        src: require("../../assets/images/comment_del.png")
      },
      on: {
        click: function click($event) {
          return _vm.delComments();
        }
      }
    }) : _vm._e(), item.lastThreeComments.length > 0 ? _c("div", {
      staticClass: "reply-con",
      on: {
        click: function click($event) {
          return _vm.toComment(item.id);
        }
      }
    }, [_vm._l(item.lastThreeComments, function (itm) {
      return _c("div", {
        key: itm.id,
        staticClass: "reply-item"
      }, [itm.commentUserId ? _c("div", {
        on: {
          click: function click($event) {
            return _vm.toComment(item.id);
          }
        }
      }, [_c("span", {
        staticClass: "name"
      }, [_vm._v(_vm._s(itm.user.nickname))]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.$t("rely")))]), _vm._v(" "), _c("span", {
        staticClass: "name"
      }, [_vm._v(_vm._s(itm.commentUser.nickname))]), _c("span", [_vm._v(" : ")]), _vm._v(_vm._s(itm.content) + " ")]) : _c("div", [_c("span", {
        staticClass: "name"
      }, [_vm._v(_vm._s(itm.user.nickname))]), _c("span", [_vm._v(" : ")]), _c("span", [_vm._v(_vm._s(itm.content))])])]);
    }), item.lastThreeComments.length == 3 ? _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t("seeMore")) + " >>")])]) : _vm._e()], 2) : _vm._e()])]);
  }), 0)], 1) : _vm._e()])]) : _vm._e(), _vm.detailData.is_comment == 1 || _vm.detailData.is_comment === null ? _c("div", {
    class: [_vm.isFocus ? "input-con1" : "input-con", _vm.$route.query.from == "community" ? "input-con2" : ""]
  }, [_c("van-field", {
    ref: "inputs",
    attrs: _defineProperty({
      rows: "1",
      autosize: "",
      type: "textarea",
      placeholder: _vm.$t(_vm.placeholder)
    }, "autosize", ""),
    on: {
      input: function input($event) {
        return _vm.input(_vm.inputValue);
      },
      focus: _vm.focus,
      blur: _vm.blur,
      keyup: _vm.getKeyCode
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isFocus,
      expression: "!isFocus"
    }],
    staticClass: "item-con"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_comment.png"),
      alt: ""
    }
  }), this.totalCount ? _c("span", [_vm._v(_vm._s(this.totalCount))]) : _c("span")]), _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.thumbsUp(_vm.detailData.postId, _vm.detailData.isLike, _vm.threadId);
      }
    }
  }, [!_vm.detailData.isLike ? _c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_like.png"),
      alt: ""
    }
  }) : _c("img", {
    attrs: {
      src: require("../../assets/images/Like1.png"),
      alt: ""
    }
  }), _vm.detailData.likeReward.likePayCount ? _c("span", [_vm._v(_vm._s(_vm.detailData.likeReward.likePayCount))]) : _c("span")]), _vm.detailData.isFavorite ? _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.toCollect(_vm.detailData.isFavorite, _vm.threadId);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Collection1.png"),
      alt: ""
    }
  }), _vm.detailData.likeReward.favoriteCount != 0 ? _c("span", [_vm._v(_vm._s(_vm.detailData.likeReward.favoriteCount))]) : _c("span")]) : _c("div", {
    staticClass: "item",
    on: {
      click: function click($event) {
        return _vm.toCollect(_vm.detailData.isFavorite, _vm.threadId);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_collect.png"),
      alt: ""
    }
  }), _vm.detailData.likeReward.favoriteCount != 0 ? _c("span", [_vm._v(_vm._s(_vm.detailData.likeReward.favoriteCount))]) : _c("span")])]), _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFocus,
      expression: "isFocus"
    }],
    class: ["send", {
      active: !_vm.isEmpty
    }],
    on: {
      click: _vm.send
    }
  }, [_vm._v(_vm._s(_vm.$t("send")))])], 1) : _vm._e(), _c("div", {
    ref: "qrCodeUrl",
    staticClass: "qrcode"
  }), _c("div", {
    staticClass: "bottom-box"
  }), _c("van-popup", {
    attrs: {
      "safe-area-inset-bottom": true,
      position: "bottom"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c("div", {
    staticClass: "pop"
  }, [_c("span", {
    on: {
      click: _vm.del
    }
  }, [_vm._v(_vm._s(_vm.$t("delete")))]), _c("span", {
    on: {
      click: _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t("cancel")))])])]), _c("van-popup", {
    staticClass: "paymentExplainClass paymentExplainClass1",
    attrs: {
      round: ""
    },
    model: {
      value: _vm.confirmTextShow,
      callback: function callback($$v) {
        _vm.confirmTextShow = $$v;
      },
      expression: "confirmTextShow"
    }
  }, [_c("div", {
    staticClass: "paymentExplainContainer"
  }, [_c("div", {
    staticClass: "text"
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.$t("pctdtc")) + " ")])]), _c("div", {
    staticClass: "popBtn"
  }, [_c("div", {
    staticClass: "okBtn canBtn",
    on: {
      click: _vm.cancelTextHandler
    }
  }, [_vm._v(_vm._s(_vm.$t("cancel")))]), _c("div", {
    staticClass: "okBtn conBtn",
    on: {
      click: _vm.confirmOKHandler
    }
  }, [_vm._v(_vm._s(_vm.$t("confirm")))])])])]), _c("van-popup", {
    staticClass: "paymentExplainClass paymentExplainClass1",
    attrs: {
      round: ""
    },
    model: {
      value: _vm.confirmPostShow,
      callback: function callback($$v) {
        _vm.confirmPostShow = $$v;
      },
      expression: "confirmPostShow"
    }
  }, [_c("div", {
    staticClass: "paymentExplainContainer"
  }, [_c("div", {
    staticClass: "text"
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.$t("pctdtp")) + " ")])]), _c("div", {
    staticClass: "popBtn"
  }, [_c("div", {
    staticClass: "okBtn canBtn",
    on: {
      click: _vm.cancelPostHandler
    }
  }, [_vm._v(_vm._s(_vm.$t("cancel")))]), _c("div", {
    staticClass: "okBtn conBtn",
    on: {
      click: _vm.confirmPostHandler
    }
  }, [_vm._v(_vm._s(_vm.$t("confirm")))])])])])], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "like"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Like1.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "name"
  }, [_c("span", [_vm._v("Quella")]), _c("span", [_vm._v(" , ")]), _c("span", [_vm._v("William")]), _vm._v(" 5164 likes. ")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };